import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';
import { TaskDueDate, TimelineEvent } from '../types';

dayjs.extend(relativeTime);
dayjs.extend(duration);

export const calculateDueDate = (dueDate: string | TaskDueDate): string => {
  if (typeof dueDate === 'string') {
    return dueDate;
  }

  const now = dayjs();
  
  switch (dueDate.unit) {
    case 'days':
      return now.add(dueDate.value, 'day').toISOString();
    case 'weeks':
      return now.add(dueDate.value, 'week').toISOString();
    case 'months':
      return now.add(dueDate.value, 'month').toISOString();
    default:
      return now.toISOString();
  }
};

export const formatRelativeDueDate = (dueDate: TaskDueDate): string => {
  return `${dueDate.value} ${dueDate.unit} after creation`;
};

export const getTimeInStage = (timeline: TimelineEvent[], currentStageId: string): string => {
  // Find the most recent stage change event for the current stage
  const stageEvent = [...timeline]
    .reverse()
    .find(event => 
      event.type === 'stage-change' && 
      event.stageId === currentStageId
    );

  // Use the first timeline event as the case creation date
  const startDate = stageEvent 
    ? dayjs(stageEvent.date)
    : dayjs(timeline[0]?.date); // Fallback to case creation date

  if (!startDate) return 'Unknown';

  const now = dayjs();
  const diff = now.diff(startDate, 'minute'); // Get difference in minutes

  // Handle negative durations (shouldn't happen in normal cases)
  if (diff < 0) return '0 minutes';

  const duration = dayjs.duration(diff, 'minute');

  if (duration.asMonths() >= 1) {
    return `${Math.floor(duration.asMonths())} months`;
  } else if (duration.asDays() >= 1) {
    return `${Math.floor(duration.asDays())} days`;
  } else if (duration.asHours() >= 1) {
    return `${Math.floor(duration.asHours())} hours`;
  } else {
    return `${Math.floor(duration.asMinutes())} minutes`;
  }
};